/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChecklistTemplateSection } from './ChecklistTemplateSection';
import {
    ChecklistTemplateSectionFromJSON,
    ChecklistTemplateSectionFromJSONTyped,
    ChecklistTemplateSectionToJSON,
} from './ChecklistTemplateSection';
import type { MachineChecklistCategory } from './MachineChecklistCategory';
import {
    MachineChecklistCategoryFromJSON,
    MachineChecklistCategoryFromJSONTyped,
    MachineChecklistCategoryToJSON,
} from './MachineChecklistCategory';

/**
 * 
 * @export
 * @interface ChecklistTemplate
 */
export interface ChecklistTemplate {
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    baseTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    machineId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChecklistTemplate
     */
    generalWarningIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ChecklistTemplate
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplate
     */
    status?: ChecklistTemplateStatusEnum;
    /**
     * 
     * @type {MachineChecklistCategory}
     * @memberof ChecklistTemplate
     */
    category?: MachineChecklistCategory;
    /**
     * 
     * @type {Array<ChecklistTemplateSection>}
     * @memberof ChecklistTemplate
     */
    sections?: Array<ChecklistTemplateSection>;
    /**
     * 
     * @type {Date}
     * @memberof ChecklistTemplate
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChecklistTemplate
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChecklistTemplate
     */
    publishedAt?: Date;
}


/**
 * @export
 */
export const ChecklistTemplateStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Disabled: 'DISABLED'
} as const;
export type ChecklistTemplateStatusEnum = typeof ChecklistTemplateStatusEnum[keyof typeof ChecklistTemplateStatusEnum];


/**
 * Check if a given object implements the ChecklistTemplate interface.
 */
export function instanceOfChecklistTemplate(value: object): value is ChecklistTemplate {
    return true;
}

export function ChecklistTemplateFromJSON(json: any): ChecklistTemplate {
    return ChecklistTemplateFromJSONTyped(json, false);
}

export function ChecklistTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'baseTemplateId': json['baseTemplateId'] == null ? undefined : json['baseTemplateId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'generalWarningIds': json['generalWarningIds'] == null ? undefined : json['generalWarningIds'],
        'version': json['version'] == null ? undefined : json['version'],
        'status': json['status'] == null ? undefined : json['status'],
        'category': json['category'] == null ? undefined : MachineChecklistCategoryFromJSON(json['category']),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(ChecklistTemplateSectionFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'publishedAt': json['publishedAt'] == null ? undefined : (new Date(json['publishedAt'])),
    };
}

export function ChecklistTemplateToJSON(value?: ChecklistTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'baseTemplateId': value['baseTemplateId'],
        'name': value['name'],
        'description': value['description'],
        'machineId': value['machineId'],
        'generalWarningIds': value['generalWarningIds'],
        'version': value['version'],
        'status': value['status'],
        'category': MachineChecklistCategoryToJSON(value['category']),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(ChecklistTemplateSectionToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'publishedAt': value['publishedAt'] == null ? undefined : ((value['publishedAt']).toISOString()),
    };
}

